export default __webpack_public_path__ + "static/media/aws-selected.67d2c6b7.svg";